import { BasicCrudService } from '@/app/common/utils/crud/basic-crud.service';
import { Injectable } from '@angular/core';
import { CityApiService } from '../infra/api.service';
import { City, CityFindAllParams, CityCreateParams } from './type';
import { User } from '../../user/core/type';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root', useClass: CityApiService })
export abstract class CityService extends BasicCrudService<
  City,
  City['id'],
  CityFindAllParams,
  City,
  CityCreateParams
> {
}
